<script lang="ts">
    export let item: Job
    item.description =
        item.description
            .replace(/<[^>]*>?/gm, "")
            .split(" ")
            .splice(0, 50)
            .join(" ") + "..."
</script>

<div class="job">
    <h4>{item.title}</h4>
    <div class="row job-infos">
        <div>{item.city}</div>
        <div>{item.area}</div>
    </div>
    <p>
        {item.description}
    </p>
    <a href="{item.url}" target="_blank" rel="nofollow" class="icon chevron-left more">Weiterlesen</a>
</div>
